import React, { useContext, useEffect, useState } from "react";
import "react-calendar/dist/Calendar.css";
import ResumenCard from "../components/ResumenCard";
import PanelDetalle from "../components/PanelDetalle";
import { NewContext } from "../utils/ContextProvider";
import { useNavigate, useParams } from "react-router-dom";
import "../css/resumenAsistencia.css";
import {
    faClock,
    faUmbrellaBeach,
    faBed,
    faUserTimes,
    faClockRotateLeft,
    faBan
} from "@fortawesome/free-solid-svg-icons";
import {
    getAbsenceByIdAndDate,
    getSuspensionByAllId,
    getHorasTrabajadasId,
    getLicenciasId,
    getLLegadasTardesId,
    getTotalWorkedHours
} from "../utils/peticionesApi";

const ResumenAsistencia = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [mostrarPanel, setMostrarPanel] = useState(null);
    const { getToken, getAlert, getDepartment } = useContext(NewContext);
    const [selectedDepartments, setSelectedDepartments] = useState([]);
    const [idDepartamento, setIdDepartamento] = useState(getDepartment);
    const hoy = new Date().toISOString().split("T")[0];
    const [ausencias, setAusencias] = useState([]);
    const [licencias, setLicencias] = useState([]);
    const [tardanzas, setTardanzas] = useState([]);
    const [horasTrabajadas, setHorasTrabajadas] = useState([]);
    const [suspensiones, setSuspensiones] = useState([]);
    const departmentIds = selectedDepartments.length > 0
        ? selectedDepartments.join(',')
        : (getDepartment?.length > 0 ? getDepartment.join(',') : '0');

    const zktecoAvailable = departmentIds !== '0';

    const [startDate, setStartDate] = useState(() => {
        const now = new Date();
        const first = new Date(now.getFullYear(), now.getMonth(), 1);
        return first.toISOString().slice(0, 10);
    });

    const [endDate, setEndDate] = useState(() => {
        const today = new Date();
        return today.toISOString().slice(0, 10);
    });

    const [resumen, setResumen] = useState({
        horasTrabajadas: 0,
        horasExtras: 0,
        licencias: 0,
        ausencias: 0,
        llegadasTarde: 0,
        suspensiones: 0,
    });

    useEffect(() => {
        if (getToken && id) {
            listarResumen();
        }
    }, [getToken, id, startDate, endDate]);

    const formatDateToDDMMYYYY = (dateString) => {
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    };

    const listarResumen = async () => {
        try {

            const rTotal = await getTotalWorkedHours(id, formatDateToDDMMYYYY(startDate), formatDateToDDMMYYYY(endDate), departmentIds, zktecoAvailable);

            const info = rTotal.data;

            setResumen(prev => ({
                ...prev,
                horasTrabajadas: info.total_worked_time ?? "0:00",
                llegadasTarde: info.total_late_arrivals ?? 0,
                licencias: info.total_leaves ?? 0,
                ausencias: info.total_absences ?? 0,
                suspensiones: info.total_suspensions ?? 0,
            }));
        } catch (error) {
            console.error("Error al listar resumen:", error);
        }
    };

    const handleCardClick = async (tipo) => {
        try {
            switch (tipo) {
                case "ausencias": {
                    if (ausencias.length > 0) return setMostrarPanel("ausencias");

                    const r = await getAbsenceByIdAndDate(id, startDate, endDate);
                    setAusencias(r.data);

                    if (r.data.length > 0) return setMostrarPanel("ausencias");
                    return getAlert({ msj: `No posee ausencias en la fecha seleccionada`, tipe: 'warning' });
                }
                case "licencias": {
                    if (licencias.length > 0) return setMostrarPanel("licencias");

                    const r = await getLicenciasId(id, startDate, endDate);
                    setLicencias(r.data);

                    if (r.data.length > 0) return setMostrarPanel("licencias");
                    return getAlert({ msj: `No posee licencias en la fecha seleccionada`, tipe: 'warning' });
                }
                case "tardanzas": {
                    if (tardanzas.length > 0) return setMostrarPanel("tardanzas");

                    const r = await getLLegadasTardesId(id, startDate, endDate);
                    setTardanzas(r.data);

                    if (r.data.length > 0) return setMostrarPanel("tardanzas");
                    return getAlert({ msj: `No posee llegadas tarde en la fecha seleccionada`, tipe: 'warning' });
                }
                case "horasTrabajadas": {

                    if (horasTrabajadas.length > 0) return setMostrarPanel("horasTrabajadas");

                    const r = await getHorasTrabajadasId(id, formatDateToDDMMYYYY(startDate), formatDateToDDMMYYYY(endDate), departmentIds, zktecoAvailable);
                    setHorasTrabajadas(r.data);

                    if (r.data.length > 0) return setMostrarPanel("horasTrabajadas");
                    return getAlert({ msj: `No posee horas en la fecha seleccionada`, tipe: 'warning' });
                }
                case "suspensiones": {
                    if (suspensiones.length > 0) return setMostrarPanel("suspensiones");

                    const r = await getSuspensionByAllId(id);
                    setSuspensiones(r.data);

                    if (r.data.length > 0) return setMostrarPanel("suspensiones");
                    return getAlert({ msj: `No posee suspensiones en la fecha seleccionada`, tipe: 'warning' });
                }
                default:
                    return;
            }
        } catch (err) {
            console.error(err);
            getAlert({ msj: `Ocurrió un error al cargar los datos`, tipe: 'error' });
        }
    };

    const getDataByTipo = () => {
        switch (mostrarPanel) {
            case "suspensiones":
                return {
                    tipo: "suspensiones",
                    data: suspensiones
                };
            case "ausencias":
                return {
                    tipo: "ausencias",
                    data: ausencias
                };
            case "licencias":
                return {
                    tipo: "licencias",
                    data: licencias
                };
            case "tardanzas":
                return {
                    tipo: "tardanzas",
                    data: tardanzas
                };
            case "horasTrabajadas":
                return {
                    tipo: "horasTrabajadas",
                    data: horasTrabajadas
                };
            default:
                return { tipo: "", data: [] };
        }
    };

    const panelInfo = getDataByTipo();

    return (
        <div className="contenedor-resumenAsistencia">

            <div className="contenedor-filtro-fechas">
                <label className="label-fechas">Fecha de periodo</label>
                <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} className="input-fecha" />
                <span className="guion-rango"> - </span>
                <input
                    type="date"
                    value={endDate}
                    max={hoy}
                    onChange={(e) => {
                        const selected = e.target.value;
                        if (selected <= hoy) {
                            setEndDate(selected);
                        } else {
                            getAlert({ msj: "No se puede seleccionar una fecha futura", tipe: "warning" });
                        }
                    }}
                    className="input-fecha"
                />
                <button onClick={listarResumen} className="boton-buscar">🔍</button>
            </div>

            <div className="contenedor-resumen-tabla">
                <ResumenCard icon={faClock} titulo="Horas trabajadas" valor={resumen.horasTrabajadas + " hs"} onClick={() => handleCardClick("horasTrabajadas")} />
                {/*<ResumenCard icon={faBusinessTime} titulo="Horas extras" valor={`${resumen.horasExtras} hs`} onClick={() => handleCardClick("horasExtras")} />*/}
                <ResumenCard icon={faUserTimes} titulo="Ausencias" valor={resumen.ausencias} onClick={() => handleCardClick("ausencias")} />
                <ResumenCard icon={faClockRotateLeft} titulo="Llegadas tarde" valor={resumen.llegadasTarde} onClick={() => handleCardClick("tardanzas")} />
                <ResumenCard
                    icon={faUmbrellaBeach}
                    titulo="Vacaciones"
                    valor={`${resumen.horasExtras} hs`}
                    onClick={() => navigate(`/vacaciones/${id}`)}
                />
                <ResumenCard icon={faBed} titulo="Licencias" valor={resumen.licencias} onClick={() => handleCardClick("licencias")} />
                <ResumenCard icon={faBan} titulo="Suspensiones" valor={resumen.suspensiones} onClick={() => handleCardClick("suspensiones")} />
            </div>

            {mostrarPanel && (
                <PanelDetalle tipo={panelInfo.tipo} data={panelInfo.data} onClose={() => setMostrarPanel(null)} />
            )}
        </div>
    );
};

export default ResumenAsistencia;
